export default {
  base: {
    color: 'grey-60',
    fontFamily: 'base',
    borderColor: 'grey-40',
    focus: {
      outlineWidth: 2,
      outlineColor: 'orange'
    },
    selected: {
      backgroundColor: 'grey-05',
      color: 'grey-100',
      borderColor: 'grey-05',
      borderWidth: 2,
      focus: {
        variant: 'spark.element.select.base.focus'
      }
    }
  },
  variants: {
    withIcon: {
      variant: 'spark.element.select.base'
    }
  }
};